// usa based phone numbers only
export const stripCountryCode = (phone: string) => {
  if (phone.length > 10) {
    return phone.substring(1);
  }

  return phone;
};
